"use strict";

module.exports = function(mode) {
	var modes = {
		"~": "owner",
		"&": "admin",
		"!": "admin",
		"@": "op",
		"%": "half-op",
		"+": "voice",
		"": "normal"
	};
	return modes[mode];
};



// WEBPACK FOOTER //
// ./client/js/libs/handlebars/modes.js